import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import AlertCards from './components/AlertCards';
import KPICards from './components/KPICards';
import StatusPieChart from './components/StatusPieChart';
import CommissionChart from './components/CommissionChart';
import ActivitiesChart from './components/ActivitiesChart';
import ActivitiesTable from './components/ActivitiesTable';
import DateRangeFilter from './components/DateRangeFilter';

const AgentActivityDashboard = ({ agentId }) => {
    // Default to last 30 days
    const [fromDate, setFromDate] = useState(
        moment()
            .subtract(30, 'days')
            .format('YYYY-MM-DD')
    );
    const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));
    const [dateType, setDateType] = useState('activityStart'); // or 'bookedOn'
    const [status, setStatus] = useState('all');

    return (
        <Grid item xs={12} container alignContent="flex-start" spacing={2}>
            <AlertCards />
            <DateRangeFilter
                fromDate={fromDate}
                toDate={toDate}
                dateType={dateType}
                status={status}
                setFromDate={setFromDate}
                setToDate={setToDate}
                setDateType={setDateType}
                setStatus={setStatus}
            />
            <ActivitiesTable
                agentId={agentId}
                fromDate={fromDate}
                toDate={toDate}
                dateType={dateType}
                status={status}
            />
            <KPICards
                agentId={agentId}
                fromDate={fromDate}
                toDate={toDate}
                dateType={dateType}
                status={status}
            />
            <StatusPieChart
                agentId={agentId}
                fromDate={fromDate}
                toDate={toDate}
                dateType={dateType}
                status={status}
            />
            <CommissionChart
                agentId={agentId}
                fromDate={fromDate}
                toDate={toDate}
                dateType={dateType}
                status={status}
            />
            <ActivitiesChart
                agentId={agentId}
                fromDate={fromDate}
                toDate={toDate}
                dateType={dateType}
                status={status}
            />
        </Grid>
    );
};

export default AgentActivityDashboard;
